<template >
  <v-container>
    <div class="custom-center justify-start" style="display:flex;">
      <v-tooltip open-delay="600" max-width="250" color="new_media" bottom style="border-radius:8em!important;">
        <template v-slot:activator="{ on }">
          <v-text-field v-on="on"
            color="new_media"
            style="max-width:300px!important;"
            class="px-3 pt-3"
            placeholder="Saisissez votre thème ici"
            prepend-inner-icon="mdi-magnify"
            v-on:keyup.enter="onlineSearch"
            v-model="query"
            :clearable="true"
            clear-icon="mdi-close-circle"
            rounded
            filled
            dense
            :hide-details="true"
          ></v-text-field>
        </template>
        <span> Pour recherchez une image saisissez un thème ou mot clé. </span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <a class="mr-5 pt-3" href="https://pixabay.com/" target="blank"><img :src="currentTheme ? logoPixabay.darkSrc : logoPixabay.lightSrc" id="logoPixabay"></a>
    </div>
    <div class="scrollNewMedia" style="height: calc(100vh + -250px);">
      <div v-if="queryVideos.length===0 && isDoneFetching && !noResult" style="height:100%!important;overflow-y:auto!important;overflow-x:visible!important;">
        <v-row no-gutters>
          <v-col cols="12">
            <div v-for="video in dailyVideos" class="col-lg-2 col-md-3 col-sm-4 d-inline-block vert-align" :key="video.id">
              <v-menu open-on-hover :close-on-content-click="false" :offset-overflow="true" open-delay="600" transition="slide-y-transition" origin="center">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="blocPhotoPixabay">
                    <v-img class="image_with_alpha" :src="video.videos.medium.width > video.videos.medium.height ? 'https://i.vimeocdn.com/video/' + video.picture_id + '_250x140' : 'https://i.vimeocdn.com/video/' + video.picture_id + '_140x250'" height="140" cover @click="showCreationModal(video)" :class=" video.videos.medium.width > video.videos.medium.height ? photoPixabay : photoPixabayPortrait">
                    </v-img>
                  </div>
                </template>
                  <video class="photoPixabay_Zoom elevation-24" style="background-color:black" :src="video.videos.small.url" :width="video.videos.small.width > video.videos.small.height ? 640 : 203" height="360" muted loop autoplay @click="showCreationModal(video)" />
              </v-menu>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="queryVideos.length>0 && isDoneFetching && !noResult" style="height:100%!important;overflow-y:auto!important;overflow-x:visible!important;">
        <v-row no-gutters>
          <v-col cols="12">
            <div v-for="video in queryVideos" class="col-lg-2 col-md-3 col-sm-4 d-inline-block vert-align" :key="video.id">
              <v-menu open-on-hover :close-on-content-click="false" :offset-overflow="true" open-delay="600" transition="slide-y-transition" origin="center">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="blocPhotoPixabay">
                    <v-img class="image_with_alpha" :src="video.videos.medium.width > video.videos.medium.height ? 'https://i.vimeocdn.com/video/' + video.picture_id + '_250x140' : 'https://i.vimeocdn.com/video/' + video.picture_id + '_140x250'" height="140" cover @click="showCreationModal(video)" :class=" video.videos.medium.width > video.videos.medium.height ? photoPixabay : photoPixabayPortrait">
                    </v-img>
                  </div>
                </template>
                  <video class="photoPixabay_Zoom elevation-24" style="background-color:black" :src="video.videos.small.url" :width="video.videos.small.width > video.videos.small.height ? 640 : 203" height="360" muted loop autoplay @click="showCreationModal(video)" />
              </v-menu>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <div v-if=" isDoneFetching && noResult">
      <h3> Aucun résultat trouvé, essayez d'autres mots clés. </h3>
    </div>
    <modals-container class="modal-container"/>
  </v-container>
</template>

<script>
import VideoUploadModal from './VideoUploadModal'
import axios from 'axios'

export default {
  data () {
    return {
      dailyVideos: [],
      queryVideos: [],
      query: '',
      isDoneFetching: false,
      photoPixabay: 'photoPixabay',
      photoPixabayPortrait: 'photoPixabay_portrait',
      zoomPhotoPixabay : 'photoPixabay_Zoom',
      zoomPhotoPixabayPortrait: 'photoPixabay_portrait_Zoom',
      clearable: true,
      noResult: false,
      currentTheme: null,
      logoPixabay: {lightSrc: require('../../assets/images/light_logoPixabay.png'), darkSrc: require('../../assets/images/dark_logoPixabay.png')}
    }
  },
  components: {
    VideoUploadModal
  },
  mounted () {
    this.currentTheme = this.$store.state.theme
    axios.get('https://pixabay.com/api/videos/?key=55785-5311f6dc11479d2611e5df625&order=latest&per_page=24&editors_choice=true&safesearch=true')
      .then((response) => {
        this.dailyVideos = response.data.hits
         this.isDoneFetching = true
      })
  },
  methods: {
    onlineSearch: function () {
      if (this.query === '') {
        this.noResult = false
        this.isDoneFetching = true
        this.queryImages = []
        return
      }
      axios.get('https://pixabay.com/api/videos/?key=55785-5311f6dc11479d2611e5df625&q=' + this.query + '&safesearch=true&per_page=24&order=popular&min_height=768&min_width=768&lang=' + this.$store.state.language)
        .then((response) => {
          this.queryVideos = response.data.hits
          this.isDoneFetching = true
          this.noResult = this.queryImages.length === 0
        })
    },
    showCreationModal: function (video) {
      this.$store.dispatch('setPixabayVideoURL', video.videos.medium.url)
      this.$store.dispatch('setPixabayImageID', video.id)
      this.$store.dispatch('setPixabayDuration', video.duration)
      this.$modal.show(VideoUploadModal, {}, {clickToClose: false, adaptive: true, width: '80%', height: 'auto', scrollable: true})
    }
  }
}
</script>

<style scoped>
.vert-align{
  vertical-align: top;
}
</style>
